/* NIGHT OPERATORS HEAT + VIPER page script. NEW FILE, 18 Oct 2026, lane HEAT-VIPER-FUNNEL-1018.
   One state for the whole page: the kit and every add-on. The white top, the setup cards, the bottom order card
   and the sticky bar all draw from it, so they can never disagree. One press puts every picked line in the cart
   through ONE /cart/add.js call, then opens the cart drawer (20 Oct 2026; the cart page only if the theme has no drawer). Prices, ids and stock come from the page data, which
   Liquid read live from Shopify. Only templates/product.heat-viper-dark.json loads this file.
   No em or en dashes. */
(function () {
  if (window.__hvdV1) return; window.__hvdV1 = true;
  var top = document.getElementById('hvd-top');
  var root = document.getElementById('no-hvd');
  if (!top) return;
  var D = null, D2 = { helmet: [] };
  try { D = JSON.parse(top.querySelector('[data-hvd-data]').textContent); } catch (e) { return; }
  try { if (root) D2 = JSON.parse(root.querySelector('[data-hvd-data2]').textContent); } catch (e) { /* no helmet row */ }

  /* the helmet list follows the visitor's market (built in Liquid, same rule as the live page) */
  var HEL = (D.helmet && D.helmet.length) ? D.helmet : (D2.helmet || []);
  var S = { kit: D.pick, g24: null, batt: '0', care: false, helmet: null, ngal: null, ins: false };
  var insInCart = false;

  function fmt(c) {
    var t = D.money || '$1,234,567.89';
    var n = (c / 100).toFixed(2).split('.'), i = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (t.indexOf('1,234,567.89') > -1) return t.replace('1,234,567.89', i + '.' + n[1]);
    if (t.indexOf('1.234.567,89') > -1) return t.replace('1.234.567,89', i.replace(/,/g, '.') + ',' + n[1]);
    if (t.indexOf('1,234,568') > -1) return t.replace('1,234,568', Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return '$' + i + '.' + n[1];
  }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function byKey(list, key) { list = list || []; for (var i = 0; i < list.length; i++) if (String(list[i].key) === String(key)) return list[i]; return null; }
  function firstOk(list) { list = list || []; for (var i = 0; i < list.length; i++) if (list[i].ok) return list[i]; return null; }
  function kit() { return D.kits[S.kit]; }

  function lines() {
    var out = [], k = kit();
    if (k) out.push({ id: k.id, name: k.name, sku: k.sku, price: k.price, ok: k.ok, kit: true });
    var a;
    if (S.g24 && (a = byKey(D.g24, S.g24)) && a.ok) out.push(a);
    if (S.batt !== '0' && (a = byKey(D.batt, S.batt)) && a.ok) out.push(a);
    if (S.care && D.care && D.care.ok) out.push(D.care);
    if (S.helmet && (a = byKey(HEL, S.helmet)) && a.ok) out.push(a);
    if (S.ngal && (a = byKey(D.ngal, S.ngal)) && a.ok) out.push(a);
    if (S.ins && D.ins && D.ins.ok && !insInCart) out.push({ id: D.ins.id, name: D.ins.name, sku: '', price: D.ins.price, ok: true, ins: true });
    return out;
  }
  function total(ls) { return ls.reduce(function (s, l) { return s + l.price; }, 0); }

  /* gallery */
  var stage = top.querySelector('[data-hvd-stage]'), thumbs = top.querySelectorAll('[data-hvd-thumb]');
  function slideTo(i, smooth) { if (stage) stage.scrollTo({ left: i * stage.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); }
  if (stage && thumbs.length) {
    thumbs.forEach(function (b) { b.addEventListener('click', function () { slideTo(+b.getAttribute('data-hvd-thumb'), true); }); });
    var t0 = null;
    stage.addEventListener('scroll', function () {
      clearTimeout(t0);
      t0 = setTimeout(function () {
        var i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
        thumbs.forEach(function (b, k) { b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      }, 80);
    }, { passive: true });
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); stage.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * stage.clientWidth, behavior: 'smooth' });
    });
  }
  function showKitPicture(smooth) {
    var k = kit(); if (!k || !stage || !k.media) return;
    var slides = stage.querySelectorAll('[data-hvd-media]');
    for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-hvd-media') === String(k.media)) { slideTo(i, smooth); return; }
  }

  function render(kitChanged) {
    var k = kit(); if (!k) return;
    var ls = lines(), tot = total(ls);
    all('[data-hvd-kit][role="radio"]').forEach(function (el) { el.setAttribute('aria-checked', el.getAttribute('data-hvd-kit') === S.kit ? 'true' : 'false'); });
    all('[data-hvd-kitcard]').forEach(function (el) { el.classList.toggle('is-picked', el.getAttribute('data-hvd-kitcard') === S.kit); });
    all('[data-hvd-kitshow]').forEach(function (el) { el.hidden = el.getAttribute('data-hvd-kitshow') !== S.kit; });
    all('[data-hvd-kitname]').forEach(function (el) { el.textContent = k.name; });
    all('[data-hvd-price]').forEach(function (el) { el.textContent = fmt(k.price); });
    all('[data-hvd-cmp]').forEach(function (el) { el.hidden = !(k.cmp > k.price); el.textContent = k.cmp > k.price ? fmt(k.cmp) : ''; });
    var sz = top.querySelector('[data-hvd-sez]');
    if (sz) {
      var fits = tot >= D.sezzleMin && tot <= D.sezzleMax;
      sz.hidden = !fits;
      if (fits) {
        sz.innerHTML = '';
        sz.appendChild(document.createTextNode('or 4 interest free payments of '));
        var b = document.createElement('b'); b.setAttribute('data-hvd-q', ''); b.textContent = fmt(Math.floor((tot + 3) / 4)); sz.appendChild(b);
        sz.appendChild(document.createTextNode(' with Sezzle' + (ls.length > 1 ? ' on your total of ' + fmt(tot) : '')));
      }
    }
    /* add-on controls */
    all('[data-hvd-sw]').forEach(function (sw) {
      var key = sw.getAttribute('data-hvd-sw');
      var on = key === 'care' ? S.care : !!S[key];
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      var row = sw.closest('[data-hvd-row]'); if (row) row.classList.toggle('is-on', on);
    });
    all('[data-hvd-opt]').forEach(function (p) {
      var key = p.getAttribute('data-hvd-opt'), v = p.getAttribute('data-v');
      p.setAttribute('aria-checked', String(S[key]) === v ? 'true' : 'false');
    });
    /* the battery card picture follows the cell count (white store photos); NONE shows the 1 cell picture faded */
    all('[data-hvd-battimg]').forEach(function (im) {
      var k = S.batt === '0' ? '1' : S.batt, u = im.getAttribute('data-src-' + k);
      if (u && im.getAttribute('src') !== u) im.setAttribute('src', u);
      im.classList.toggle('is-none', S.batt === '0');
    });
    /* add-on pictures and links follow the picked variant; before a pick they show the first one in stock (Bon 20 Oct) */
    all('[data-hvd-vimg]').forEach(function (im) {
      var key = im.getAttribute('data-hvd-vimg'), list = key === 'helmet' ? HEL : D[key];
      var v = (S[key] && byKey(list, S[key])) || firstOk(list);
      if (v && v.img && im.getAttribute('src') !== v.img) im.setAttribute('src', v.img);
      if (v && v.name) im.setAttribute('alt', v.name);
    });
    all('[data-hvd-vlink]').forEach(function (a) {
      var key = a.getAttribute('data-hvd-vlink'), list = key === 'helmet' ? HEL : D[key];
      var v = (S[key] && byKey(list, S[key])) || firstOk(list), base = a.getAttribute('data-base');
      if (v && base) a.setAttribute('href', base + '?variant=' + v.id);
    });
    /* cart list and totals */
    var ul = top.querySelector('[data-hvd-lines]');
    if (ul) {
      ul.innerHTML = '';
      ls.forEach(function (ln) {
        var li = document.createElement('li'), sp = document.createElement('span'), sm = document.createElement('small'), b = document.createElement('b');
        sp.textContent = ln.name; sm.textContent = 'qty 1'; sp.appendChild(sm);
        b.textContent = fmt(ln.price); li.appendChild(sp); li.appendChild(b); ul.appendChild(li);
      });
    }
    all('[data-hvd-total]').forEach(function (el) { el.textContent = fmt(tot); });
    all('[data-hvd-addamt]').forEach(function (el) { el.textContent = k.ok ? fmt(tot) : ''; });
    all('[data-hvd-add]').forEach(function (b) {
      b.disabled = !k.ok;
      var l = b.querySelector('[data-hvd-addlabel]'); if (l) l.textContent = k.ok ? 'ADD TO CART' : 'SOLD OUT';
    });
    /* the store's delivery estimate reads the theme style variant input */
    var vid = top.querySelector('[data-hvd-vid]');
    if (vid && vid.value !== String(k.id)) {
      vid.value = String(k.id);
      try { vid.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* old browser */ }
    }
    if (kitChanged) showKitPicture(true);
  }

  function nearest() {
    var form = top.querySelector('.hvd-step'), ord = document.getElementById('hvd-order');
    if (!ord) return form;
    var mid = window.innerHeight / 2;
    var a = form.getBoundingClientRect(), b = ord.getBoundingClientRect();
    return Math.abs(a.top - mid) <= Math.abs(b.top - mid) ? form : ord;
  }
  function go(where) {
    var el = where === 'top' ? top.querySelector('.hvd-step') : where === 'order' ? document.getElementById('hvd-order') : nearest();
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function onPress(t, e) {
    var c;
    if ((c = t.closest('[data-hvd-kit]'))) {
      if (c.getAttribute('aria-disabled') === 'true' || c.disabled) return true;
      var nk = c.getAttribute('data-hvd-kit');
      var ch = nk !== S.kit; S.kit = nk; render(ch);
      if (c.hasAttribute('data-hvd-go')) go(c.getAttribute('data-hvd-go'));
      return true;
    }
    if ((c = t.closest('[data-hvd-sw]'))) {
      var key = c.getAttribute('data-hvd-sw'), f;
      if (key === 'care') S.care = !S.care;
      else if (key === 'g24') { f = firstOk(D.g24); S.g24 = S.g24 ? null : (f ? f.key : null); }
      else if (key === 'helmet') { f = firstOk(HEL); S.helmet = S.helmet ? null : (f ? String(f.key) : null); }
      else if (key === 'ngal') { f = firstOk(D.ngal); S.ngal = S.ngal ? null : (f ? String(f.key) : null); }
      render(false); return true;
    }
    if ((c = t.closest('[data-hvd-opt]'))) {
      if (c.disabled) return true;
      var k2 = c.getAttribute('data-hvd-opt'), v = c.getAttribute('data-v');
      if (k2 !== 'batt' && String(S[k2]) === v) S[k2] = null; else S[k2] = v;
      render(false); return true;
    }
    if ((c = t.closest('[data-hvd-add]'))) { if (e) e.preventDefault(); add(); return true; }
    if ((c = t.closest('[data-hvd-go]'))) { go(c.getAttribute('data-hvd-go')); return true; }
    if ((c = t.closest('[data-hvd-pop]'))) {
      var dlg = document.querySelector('[data-hvd-popup="' + c.getAttribute('data-hvd-pop') + '"]');
      if (dlg && dlg.showModal) dlg.showModal();
      return true;
    }
    if ((c = t.closest('[data-hvd-popclose]'))) { var d = c.closest('dialog'); if (d) d.close(); return true; }
    if (t.tagName === 'DIALOG') { t.close(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) { if (e.target && e.target.closest) onPress(e.target, e); });
  document.addEventListener('keydown', function (e) {
    var c = e.target.closest && e.target.closest('[data-hvd-kit][role="radio"]');
    if (!c || c.tagName === 'BUTTON' || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault(); onPress(c, null);
  });
  var form = top.querySelector('[data-hvd-form]');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

  var busy = false;
  function add() {
    var k = kit(); if (!k || !k.ok || busy) return;
    var ls = lines();
    var errs = all('[data-hvd-err]');
    errs.forEach(function (x) { x.hidden = true; });
    busy = true;
    all('[data-hvd-add]').forEach(function (b) { b.disabled = true; });
    insCheck().then(function () { ls = lines(); return fetch(D.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ls.map(function (l) { return { id: l.id, quantity: 1 }; }) })
    }); }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Could not add to cart');
        if (window.__hvdNoNav) { busy = false; render(false); window.__hvdLastAdd = x.j; return; }
        if (ls.some(function (l) { return l.ins; })) insInCart = true;
        busy = false; render(false);
        if (window.noCartDrawerOpen) { window.noCartDrawerOpen(x.j); return; }
        window.location.href = D.cartUrl;
      })
      .catch(function (err) {
        busy = false;
        errs.forEach(function (el) { el.textContent = err.message + '. Please try again, or email info@nightoperators.com.'; el.hidden = false; });
        render(false);
      });
  }
  /* before / after slider (the original page's comparison slider, rebuilt) */
  all('[data-hvd-baslider]').forEach(function (r) {
    var box = r.closest('[data-hvd-ba]');
    var set = function () { if (box) box.style.setProperty('--hvd-ba', r.value + '%'); };
    r.addEventListener('input', set); set();
  });
  /* the YouTube film loads only when pressed */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hvd-yt]');
    if (!b) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-hvd-yt') + '?autoplay=1&rel=0';
    f.title = 'HEAT and VIPER film'; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
    f.className = 'hvd-yt-frame';
    b.parentNode.replaceChild(f, b);
  });
  /* the intro background video loads when it comes near the screen, plays muted on a loop */
  var lazyV = all('[data-hvd-lazyvideo]');
  if (lazyV.length) {
    var loadV = function (v) { if (!v.src) { v.src = v.getAttribute('data-hvd-lazyvideo'); var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { loadV(en.target); io2.unobserve(en.target); } }); }, { rootMargin: '400px' });
      lazyV.forEach(function (v) { io2.observe(v); });
    } else { lazyV.forEach(function (v) { loadV(v); }); }
  }

  /* Bon 20 Oct (153A, 154A): the original buy column's Loox stars, WARNING strip and shipping insurance checkbox are rendered
     by the theme as blocks right after this one; move each into its slot in the new buy column. Unmoved, they show under it. */
  function slotIn() {
    var sec = top.closest('.shopify-section') || document;
    var map = { stars: '[id*="loox_reviews_loox_rating"]', warn: '.urgency-text', axe: '[id*="axe_checkbox_upsell"]' };
    Object.keys(map).forEach(function (k) {
      var slot = top.querySelector('[data-hvd-slot="' + k + '"]'); if (!slot || slot.firstElementChild) return;
      var el = Array.prototype.slice.call(sec.querySelectorAll(map[k])).filter(function (e) { return !top.contains(e); })[0];
      if (el) { slot.appendChild(el); slot.hidden = false; }
    });
  }
  slotIn();

  /* shipping insurance: mirrors the cart drawer's own switch (on by default), so the buy column, the drawer and the cart agree */
  function drawerIns() { return D.ins ? document.querySelector('cart-drawer-upsell[data-id="' + D.ins.id + '"]') : null; }
  function insCheck() {
    if (!D.ins) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { insInCart = (c.items || []).some(function (i) { return String(i.variant_id) === String(D.ins.id); }); })
      .catch(function () { /* keep the last known state */ });
  }
  function repaintDrawer(sections) {
    var d = document.querySelector('cart-drawer'); if (!d || !sections || typeof d.getSectionsToRender !== 'function') return;
    d.getSectionsToRender().forEach(function (s) {
      var html = sections[s.section || s.id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = s.selector ? doc.querySelector(s.selector) : doc.getElementById(s.id);
      var dst = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
  }
  function removeIns() {
    var d = document.querySelector('cart-drawer'), ids = ['cart-drawer', 'cart-icon-bubble'];
    try { if (d && d.getSectionsToRender) ids = d.getSectionsToRender().map(function (s) { return s.section || s.id; }); } catch (e) { /* default ids */ }
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(D.ins.id), quantity: 0, sections: ids.join(','), sections_url: location.pathname }) })
      .then(function (r) { return r.json(); }).then(function (j) { insInCart = false; repaintDrawer(j && j.sections); }).catch(function () {});
  }
  var insRow = top.querySelector('[data-hvd-ins]'), insCb = top.querySelector('[data-hvd-ins-cb]');
  if (insRow && insCb && D.ins && drawerIns()) {
    insRow.hidden = false;
    S.ins = drawerIns().getAttribute('data-selected') !== 'false';
    insCb.checked = S.ins;
    insCb.addEventListener('change', function () {
      S.ins = insCb.checked;
      var u = drawerIns(); if (u) u.setAttribute('data-selected', S.ins ? 'true' : 'false');
      render(false);
      if (!S.ins) insCheck().then(function () { if (insInCart) return removeIns(); }).then(function () { render(false); });
    });
    insCheck().then(function () { render(false); });
  }

  window.__hvdState = S; window.__hvdLines = lines; window.__hvdRender = render;

  render(false);
  showKitPicture(false);
  window.addEventListener('load', function () { showKitPicture(false); });

  /* sticky bar: after the top buy box leaves the screen, never over the hero, hidden while the order section shows */
  var bar = root && root.querySelector('[data-hvd-sticky]');
  var startEl = top.querySelector('[data-hvd-add]');
  var hero = document.getElementById('hvd-hero'), ord = document.getElementById('hvd-order');
  if (bar && startEl && ord) {
    var raf = 0;
    var sync = function () {
      raf = 0;
      var vh = window.innerHeight, s = startEl.getBoundingClientRect(), o = ord.getBoundingClientRect();
      var h = hero ? hero.getBoundingClientRect() : { top: 1, bottom: 0 };
      var on = s.bottom < 0 && !(o.top < vh && o.bottom > 0) && !(h.top < vh && h.bottom > 0);
      bar.classList.toggle('hy-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    };
    var ask = function () { if (!raf) raf = requestAnimationFrame(sync); };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    sync();
  }
})();
